<template>
  <v-container id="tema-list">
    <v-row>
      <v-col>Temas</v-col>
      <v-col class="text-right">
        <app-modal-insert-tema
          :edit="false"
          :object="null"
          :color="'success'"
          :icon="'mdi-plus-circle'"
          @on-save="loadTemas"
        >
          <template v-slot:title :edit="false"> Cadastrar Temas </template>
        </app-modal-insert-tema>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="payload"
          class="elevation-1"
          hide-default-footer
          disable-pagination
        >
          <template v-slot:item.nome="{ item }">
            <span>
              {{ item.nome }}
            </span>
          </template>

          <template v-slot:item.acoes="{ item }">
            <v-row>
              <v-col>
                <app-modal-insert-tema
                  :object="item"
                  :edit="true"
                  :color="'warning'"
                  :icon="'mdi-pencil'"
                  @on-save="loadTemas"
                >
                  <template v-slot:title> Edição de Temas </template>
                </app-modal-insert-tema>
              </v-col>
            </v-row>
          </template>

          <template v-slot:item.acoes_delete="{ item }">
            <v-row>
              <v-col>
                <app-modal-delete :object="item" @on-save="loadTemas">
                  <template v-slot:title> Deletar Tema </template>
                </app-modal-delete>
              </v-col>

              <v-col cols="1"> </v-col>
            </v-row>
          </template>

          <template slot="no-data">
            <span> Nenhum Tema retornado </span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AppModalInsertTema from "./ModalInsert";
import { temaAPI } from "../API/temaAPI";
import { mapActions, mapGetters } from "vuex";
import AppModalDelete from "./../components/ModalDelete";

export default {
  components: {
    AppModalInsertTema,
    AppModalDelete,
  },
  data() {
    return {
      headers: [
        { text: "Temas", value: "nome" },
        { text: "Editar", value: "acoes", sortable: false },
        { text: "Excluir", value: "acoes_delete", sortable: false },
      ],
      payload: [],
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    loadTemas() {
      this.setLoading(true);
      temaAPI
        .list()
        .then((resp) => {
          this.payload = resp.data;
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter URs");
        });
    },
  },
  mounted() {
    this.loadTemas();
  },
  computed: {
    ...mapGetters(["isAdmin"]),
  },
};
</script>
